import { IS_WIND_DOWN_ACTIVE } from './windDownConfig';
/**
 * Pools that no longer accept new deposits. Withdrawals stay open so existing
 * depositors can still exit — only the Deposit tab is closed off.
 */
export const DEPOSIT_DISABLED_POOLS = [
    // Navi USDC-USDT looping pool
    '0xb90c7250627e0113df2e60d020df477cac14ca78108e3c5968230f3e7d4d8846',
    // Navi DEEP
    '0x16a5cc859b1af17b7478c79ff43e67cc5f5e5d257fba21839060dd398a9eb958',
    // Navi WAL
    '0x8ceca427f6fef09f7691eb2c9f1bf41e4854230f9e1bd21322b3ea7f76ee6975',
    // Navi suiUSDT
    '0x1d30d1b07d78341810a604ad34734001b3b70362c6502de2220999074429a641',
    // Navi stSUI
    '0xd1125035ab6e2889239442031c130c641b75b430b71057bb79710ad578cc2867',
    // Navi NAVX
    '0x35f7260fefe3dde7fa5b4bf1319f15554934a94c74acd4ba54161f99470c348f',
    // Navi NS
    '0x55b7ae7eb570d3d2ee89a92dd8d958794f1e39c4ee067b28655359c0a152b3aa',
    // Navi AUSD
    '0x8ebe04b51e8a272d4db107ad19cfbc184d1dafeeaab0b61c26e613b804e7777a',
    // Navi suiETH
    '0xc37ec956fdef6c217505e62444ab93f833c20923755d67d1c8588c9b093ae00e',
];
/**
 * Whether a pool is closed to new deposits. While wind-down mode is on this is
 * true for every pool, not just the ones listed above.
 */
export const isDepositDisabledPool = (poolId) => {
    if (IS_WIND_DOWN_ACTIVE)
        return true;
    return !!poolId && DEPOSIT_DISABLED_POOLS.includes(poolId);
};
